import React from 'react'
import { Row, Col, Form} from 'react-bootstrap';
import Datetime from 'react-datetime';
import moment from 'moment';
import { regEx } from '../../../resources/Utils';

const WaiveInfo = ({waiveInfo, onChange, disabled}) => {
    return (
        <React.Fragment>
            <Row className="mt-5">
                <Col sm={12} className="font-weight-bold">
                    Waiver
                </Col>
            </Row>
            <Row className="my-3">
                <Col sm={12}>
                    <Row>
                        <Col sm={6}>
                            <Form.Label className="text-grey font-weight-bold medium required">Waive Flag</Form.Label>
                            <Form.Group controlId="isWaive">
                                <Row>
                                    <Col sm={6}>
                                        <Form.Check
                                            custom
                                            type={"radio"}
                                            label={"No"}
                                            name={"isWaive"}
                                            id={"isWaive-no"}
                                            checked={waiveInfo.isWaive==="N"}
                                            disabled={disabled}
                                            onChange={() => onChange("waiveInfo", "isWaive", "N")}
                                            required
                                        />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Check
                                            custom
                                            type={"radio"}
                                            label={"Yes"}
                                            name={"isWaive"}
                                            id={"isWaive-yes"}
                                            checked={waiveInfo.isWaive==="Y"}
                                            disabled={disabled}
                                            onChange={() => onChange("waiveInfo", "isWaive", "Y")}
                                            required
                                        />
                                    </Col>
                                </Row>
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group controlId="isValidTillCancel" >
                                <Form.Label className="text-grey font-weight-bold medium">&nbsp;</Form.Label>
                                <Form.Check
                                    custom
                                    type={"checkbox"}
                                    label={"Valid till canceled / modified"}
                                    name={"isValidTillCancel"}
                                    id={"isValidTillCancel"}
                                    checked={waiveInfo.isValidTillCancel}
                                    disabled={disabled || waiveInfo.isWaive==="N"}
                                    onChange={(e) => onChange("waiveInfo", "isValidTillCancel", e.target.checked)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <Form.Group controlId="waiveFrom">
                                <Form.Label className="text-grey font-weight-bold medium required">Waive From</Form.Label>
                                <Datetime
                                onChange={(date) => {
                                    const dateStr = moment.isMoment(date) ? date.format("YYYYMMDD") : date;
                                    onChange("waiveInfo", "waiveFrom", dateStr);
                                }}
                                dateFormat="DD MMM YYYY"
                                timeFormat={false}
                                inputProps={{ required: true, placeholder: "Enter waive date from", disabled: disabled || waiveInfo.isWaive==="N"}}
                                value={moment(waiveInfo.waiveFrom, "YYYYMMDD", true).isValid() ? moment(waiveInfo.waiveFrom, "YYYYMMDD", true) : waiveInfo.waiveFromDate}
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group controlId="waiveTo">
                                <Form.Label className="text-grey font-weight-bold medium required">Waive To</Form.Label>
                                <Datetime
                                onChange={(date) => {
                                    const dateStr = moment.isMoment(date) ? date.format("YYYYMMDD") : date;
                                    onChange("waiveInfo", "waiveTo", dateStr);
                                }}
                                dateFormat="DD MMM YYYY"
                                timeFormat={false}
                                inputProps={{ required: true, placeholder: "Enter waive date to", disabled: disabled || waiveInfo.isWaive==="N" || (waiveInfo.isWaive==="Y" && waiveInfo.isValidTillCancel) }}
                                value={moment(waiveInfo.waiveTo, "YYYYMMDD", true).isValid() ? moment(waiveInfo.waiveTo, "YYYYMMDD", true) : waiveInfo.waiveFromDate}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <Form.Label className="text-grey font-weight-bold medium required">Type of Waiver</Form.Label>
                            <Form.Group controlId="isWaive">
                                <Row>
                                    <Col sm={6}>
                                        <Form.Check
                                            custom
                                            type={"radio"}
                                            label={"Full"}
                                            name={"waiveType"}
                                            id={"fullWaive"}
                                            checked={waiveInfo.waiveType==="F"}
                                            disabled={disabled || waiveInfo.isWaive==="N"}
                                            onChange={() => onChange("waiveInfo", "waiveType", "F")}
                                            required
                                        />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Check
                                            custom
                                            type={"radio"}
                                            label={"Partial"}
                                            name={"waiveType"}
                                            id={"partialWaive"}
                                            checked={waiveInfo.waiveType==="P"}
                                            disabled={disabled || waiveInfo.isWaive==="N"}
                                            onChange={() => onChange("waiveInfo", "waiveType", "P")}
                                            required
                                        />
                                    </Col>
                                </Row>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <Form.Group controlId="waiveBy">
                                <Form.Label className="text-grey font-weight-bold medium required">Waive By</Form.Label>
                                <Form.Control 
                                    as="select" 
                                    name="waiveBy" 
                                    onChange={(e) => onChange('waiveInfo', e.target.name, e.target.value)}
                                    value={waiveInfo ? waiveInfo.waiveBy : ''} 
                                    disabled={disabled || waiveInfo.isWaive==="N" || (waiveInfo.isWaive==="Y" && waiveInfo.waiveType!=="P")}
                                    required>
                                    <option value="" hidden>Select</option>
                                    <option value="P">Percentage</option>
                                    <option value="A">Amount</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        {waiveInfo.waiveBy === "A" &&
                        <Col sm={6}>
                            <Form.Group controlId="waiveAmount">
                            <Form.Label className="text-grey font-weight-bold medium required">Waive Amount</Form.Label>
                            <Form.Control
                                name="waiveAmt"
                                type="text"
                                placeholder="Enter waive amount"
                                disabled={disabled || waiveInfo.isWaive==="N" || (waiveInfo.isWaive==="Y" && waiveInfo.waiveType!=="P")}
                                onChange={(e) => onChange('waiveInfo', e.target.name, e.target.value, "DECIMAL")}
                                maxLength={10}
                                pattern={regEx.DECIMAL}
                                title="Waive amount should be decimal"
                                value={waiveInfo ? waiveInfo.waiveAmt : ''}
                                required
                            />
                            </Form.Group>
                        </Col> 
                        }
                        {waiveInfo.waiveBy === "P" &&
                        <Col sm={6}>
                            <Form.Group controlId="waivePercentage">
                            <Form.Label className="text-grey font-weight-bold medium required">Waive Percentage</Form.Label>
                            <Form.Control
                                name="waivePercentage"
                                type="text"
                                placeholder="Enter waive percentage"
                                disabled={disabled || waiveInfo.isWaive==="N" || (waiveInfo.isWaive==="Y" && waiveInfo.waiveType!=="P")}
                                onChange={(e) => onChange('waiveInfo', e.target.name, e.target.value, "DECIMAL")}
                                maxLength={10}
                                pattern={regEx.PERCENTAGE}
                                title="Waive percentage should be percentage"
                                value={waiveInfo ? waiveInfo.waivePercentage : ''}
                                required
                            />
                            </Form.Group>
                        </Col> 
                        }
                    </Row>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default WaiveInfo
